const SOUNDS = {
    ALARM: require('./alarm.mp3')
}

export default SOUNDS;